import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function Contact() {
  return <DashboardLayout>Contact</DashboardLayout>;
}

export default Contact;
